import {PositionDTO} from '@staff-app/models/positionDTO';
import {
  PositionActions,
  PositionActionTypes
} from '@staff-app/actions/position.actions';
import {CommonActionTypes, CommonActions} from '@store/actions/common.actions';

export interface State {
  isDataLoadedFromDB: boolean;
  positions: PositionDTO[];
}

export const initialState: State = {
  isDataLoadedFromDB: false,
  positions: null,
};

export function reducer(
  state = initialState,
  action: PositionActions | CommonActions
): State {
  switch (action.type) {
    case PositionActionTypes.GetAvailableAndSelectedPositionsSuccessful: {
      return {
        ...state,
        isDataLoadedFromDB: true,
        positions: action.payload
      };
    }
    case PositionActionTypes.SaveSelectedPositionsSuccessful:
    case PositionActionTypes.NavigateAway:
    case CommonActionTypes.NavigateToSubmitPage: {
      return initialState;
      // remove store to prevent data load from cache
    }
    default: {
      return state;
    }
  }
}
export const isPositionsLoadedFromDB = (state: State) => state.isDataLoadedFromDB;
export const getAvailablePositions = (state: State) => state.positions;

export const getSelectedPositions = (state: State) => !!state.positions ? state.positions.filter(p => p.isSelected) : state.positions;

